import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initCacheInvalidationService } from "./services/cacheInvalidationService";

// Initialize cache invalidation service with WebSocket connection (only if configured)
initCacheInvalidationService();

// Define the future flags for React Router v7 compatibility
// This addresses the warning about v7_relativeSplatPath
// See: https://reactrouter.com/upgrading/v6

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* 
      Add future flag to opt-in to React Router v7 behavior early
      This will prevent one of the console warnings and ensure smoother migration to v7
      Note: We're only using v7_relativeSplatPath as v7_startTransition may not be supported in our version
    */}
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
